import React from 'react'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import Layout from './layout'

function DragAndDrop({
  containerRef,
  onMove,
  onDrop,
  itemType,
  list,
  containerClassName,
  className,
  ...props
}) {
  return (
    <DndProvider backend={HTML5Backend}>
      <Layout
        containerRef={containerRef}
        containerClassName={containerClassName}
        onMove={onMove}
        onDrop={onDrop}
        itemType={itemType}
        list={list}
        className={className}
        {...props}
      />
    </DndProvider>
  )
}

export default DragAndDrop
